// engine
import { ArController } from '@aceroll/core';

import { platform } from '../../platform';

export class Splash extends ArController {
    onStart() {
        this.context.setLayout('Splash');

        platform.onceClickScreen().then(() => {
            this.stop();
        });
    }
}